"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  tableHead: {
    '&.fixed': {
      position: 'sticky',
      top: 0,
      zIndex: 3
    },
    '& .scTableRow': {
      backgroundColor: theme.table.cellHeaderBgColor,
      '&:hover': {
        backgroundColor: theme.table.cellHeaderBgColor,
        cursor: 'default'
      },
      '& .scTableCell': {
        overflow: 'initial',
        whiteSpace: 'initial',
        textOverflow: 'initial',
        color: theme.table.cellHeaderColor,
        fontSize: theme.table.cellFontSize,
        fontWeight: 'normal'
      }
    },
    '& .scTableRowList': {
      minHeight: 0,
      paddingTop: 0,
      paddingBottom: 0,
      '& .scTableCell': {
        paddingBottom: 12,
        paddingTop: 12
      }
    }
  }
});

exports.default = _default;